export const DownloadCenter = (builder) => ({
    DownloadCenter: builder.mutation({
        query: ({ startDate, endDate, user_id, login_user }) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/cdrDetailsDownloads',
                method: 'GET',
                params: { startDate, endDate, user_id, login_user },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});